import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import styles from './styles.scss'

import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Input from 'react-toolbox/lib/input';

import { getCurrentWeekAndYear } from 'helpers/DateUtil'
import {
    roleOptionsSelector
} from 'containers/Project/WeeklyUpdateSection/selectors'

import WeekSelection from '../../Project/WeeklyUpdateSection/NewUpdateDialog/WeekSelection'

import SubmitButton from './SubmitButton'

import { nameSelector } from 'containers/User/Login/selectors'
const mapStateToProps = state => {
    return {
        roleOptions: roleOptionsSelector(state),
        username: nameSelector(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

class WeeklyUpdatesTab extends Component {
    constructor(props) {
        super(props)
        const weekAndYear = getCurrentWeekAndYear(new Date())

        this.state = {
            username: props.username,
            week: weekAndYear.week,
            year: weekAndYear.year,
            weekly_update_role: "",
            weekly_update_text: ""
        }
    }

    handleUpdateMessage = (input) => {
        this.setState({ weekly_update_text: input })
    }

    handleUpdateRole = (role) => {
        this.setState({ weekly_update_role: role })
    }

    handleUpdateWeek = (week) => {
        this.setState({ week: week })
    }

    handleUpdateYear = (year) => {
        this.setState({ year: year })
    }

    cancelState = () => {
        const weekAndYear = getCurrentWeekAndYear(new Date())
        this.setState(

            this.state = {
                week: weekAndYear.week,
                year: weekAndYear.year,
                weekly_update_role: "",
                weekly_update_text: ""
            }
        )
    }
    render() {
        const {
            roleOptions,
            numberOfProjects
          } = this.props
        return (
            <div>
                <SubmitButton numberOfProjects={numberOfProjects} cancelState={this.cancelState} formDetails={this.state} formType="weeklyUpdates" />
            <div styleName='weekSelectionContainer'>
                <WeekSelection 
                    week={this.state.week}
                    year={this.state.year}
                    updateWeek={this.handleUpdateWeek}
                    updateYear={this.handleUpdateYear}
                    />
                <div styleName='roleSelection'>
                    <div>Role</div>
                    <Dropdown value={this.state.weekly_update_role} source={roleOptions} onChange={this.handleUpdateRole} />
                </div>
                <div styleName='messageContainer'>
                    <div>Message</div>
                    <Input styleName='message' theme={styles} value={this.state.weekly_update_text} onChange={this.handleUpdateMessage} multiline />
                </div>
            </div>
            </div>
        )
    }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(WeeklyUpdatesTab)